import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import './startSection.scss';
import { GetSearchItem } from "../../../../api/useSearch";
import Autocomplete from '@mui/material/Autocomplete';
import OptionItem from "./components/OptionItem";
import { useTranslation } from "react-i18next";

export default function StartSection() {
  const user = useSelector((state: any) => state.user);
  const { t } = useTranslation();
  
  const dispatch = useDispatch();
  const [searchText, setSearchText] = useState("");
  const [options, setOptions] = useState<
    {
      label: string;
      value: string;
      image?: string;
      address?: string;
      type: string;
      discount?: number;
      priceBefore?: number;
      priceNow?: number;
      description?: string;
      category?: string;
    }[]
  >([]);
  
  const fetchSearchResults = async (text: string) => {
    try {
      const response = user && user.id
        ? await GetSearchItem(user.id, text)
        : await GetSearchItem("", text);
      
      //const restaurants = response?.restaurants || [];
      const dineInAds = response?.dineInAds || [];
      const takeOutAds = response?.takeOutAds || [];
      
      const combinedOptions = [
        /* ...restaurants.map((item: any) => ({
          label: item.name,
          value: item.id,
          image: item.images[0],
          address: item.addresses[0],
          type: "restaurant",
        })), */
        ...dineInAds.map((item: any) => ({
          label: item.name,
          value: item.id,
          image: item.images[0],
          discount: item.discount,
          category: item?.tags[0],
          type: "dineIn",
        })),
        ...takeOutAds.map((item: any) => ({
          label: item.name,
          value: item.id,
          priceBefore: item.priceBefore,
          priceNow: item.priceNow,
          description: item.description,
          image: item.image,
          category: item?.tags[0] || "",
          type: "takeOut",
        })),
      ];
      
      setOptions(combinedOptions);
      
      console.log("combinedOptions: ", combinedOptions);
    } catch (error) {
      console.error("Error fetching search results:", error);
    }
  };
  
  useEffect(() => {
    if (searchText) {
      const delayDebounceFn = setTimeout(() => {
        fetchSearchResults (searchText).then (r  => console.log("search result: ", r));
      }, 300);
      
      return () => clearTimeout(delayDebounceFn);
    }
  }, [searchText]);
  
  /* useEffect (() => {
        if (searchText) {
            if (user && user.id) {
                GetSearchItem(user.id, searchText).then((response: any) => {
                    console.log("GetSearchItem auth response: ", response);
                });
            } else {
                GetSearchItem("", searchText).then((response: any) => {
                    console.log("GetSearchItem not auth response: ", response);
                });
            }
        }
    }, [searchText]); */
    
    return (
        <div className="startSection__container">
            <div className="startSection__container_content">
                <div className="startSection__container_content_title">
                    <h1>{t('main.discountsThatTasteGood')}</h1>
                </div>
                <div className="startSection__container_content_subtitle">
                    <h2>{t('main.instantAccessTo')}</h2>
                </div>
                <div className="startSection__container_content_search all">
                    <div className="startSection__container_content_search_input">
                      <Autocomplete
                        sx={{
                          width: '100%',
                          '& .MuiInputBase-root': {
                            padding: 0,
                            height: '100%',
                          },
                          '& input': {
                            width: '100%',
                            height: '100%',
                            border: 'none',
                            outline: 'none',
                            fontSize: '16px',
                            padding: '10px',
                            backgroundColor: 'transparent',
                            color: 'inherit',
                          },
                        }}
                        id="custom-input-demo"
                        options={options}
                        getOptionLabel={(option: any) => option.label || ''}
                        onInputChange={(event, value) => {
                          setSearchText(value);
                          
                          const selectedOption = options.find(option => option.label === value);
                          
                          if (selectedOption && selectedOption.category) {
                            window.location.href = `/food/${selectedOption.category}/${selectedOption.value}`;
                          }
                        }}
                        renderInput={(params) => (
                          <div ref={params.InputProps.ref} className="startSection__container_content_search_input_text">
                            <input
                              type="text"
                              placeholder={t('main.searchForFood')}
                              {...params.inputProps}
                              //value={searchText}
                              //onChange={(e) => setSearchText(e.target.value)}
                            />
                          </div>
                        )}
                        renderOption={(props, option) => <OptionItem key={option.value} allProps={props} option={option} /> }
                      />
                        {/* <input
                            className="startSection__container_content_search_input_text"
                            type="text"
                            placeholder="Search for food, cuisine or restaurant"
                            value={searchText}
                            onChange={(e) => setSearchText(e.target.value)}
                        /> */}
                    </div>
                    <div className="startSection__container_content_search_icon">
                        <img
                            src={process.env.PUBLIC_URL + '/images/magnifier.svg'}
                            alt="magnifier icon"
                        />
                    </div>
                </div>
                {/* <div className="startSection__container_content_search zip">
                    <div className="startSection__container_content_search_input">
                        <input
                            className="startSection__container_content_search_input_text"
                            type="text"
                            placeholder="Zip-code"
                            value={searchZipCode}
                            onChange={(e) => setSearchZipCode(e.target.value)}
                        />
                    </div>
                    <div className="startSection__container_content_search_icon">
                        <img
                            src={process.env.PUBLIC_URL + '/images/magnifier.svg'}
                            alt="magnifier icon"
                        />
                    </div>
                </div> */}
            </div>
        </div>
    );
}